import { Loader2 } from "lucide-react";

import useTranslations from "@/shared/lang/useTranslations";

import type { VerificationPurpose } from "../types/verification-api.types";

/** Async waiting screen — not a spinner-forever; status arrives via polling/socket. */
export function ProcessingScreen({ purpose }: { purpose: VerificationPurpose }) {
  const { t } = useTranslations("verification");
  return (
    <div className="space-y-6 text-center" aria-live="polite">
      <span className="mx-auto flex size-14 items-center justify-center rounded-full bg-primary/10 text-primary">
        <Loader2 className="size-7 animate-spin" aria-hidden="true" />
      </span>
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-foreground">
          {t(purpose === "KYB" ? "processing_kyb_title" : "processing_kyc_title")}
        </h1>
        <p className="text-sm text-muted-foreground">{t("processing_note")}</p>
      </div>
    </div>
  );
}
